import { defineStore, storeToRefs } from "pinia";
import { ref, computed } from "vue";
import useMyFetch from "@stores/useMyFetch";
import { useSurveyStore } from "@stores/survey/survey";

export const useSearchGroupListStore = defineStore("searchGroupList", () => {
  const surveyStore = useSurveyStore();
  const { token } = storeToRefs(surveyStore);

  // FIXME: this is function has to be in its own store searchGroupsStore
  const searchGroups = ref([]);

  async function fetchSearchGroups() {
    const surveyToken = token.value;
    const { response, data } = await useMyFetch(`/surveys/${surveyToken}/search_groups`).get().json();
    if (response.value.ok) searchGroups.value = data.value;
  }

  const groupOptions = computed(() => searchGroups.value.map((group) => ({ label: group.name, value: group.token })));

  const populationOptions = computed(() => {
    return [{ label: "All respondents", value: "all" }].concat(groupOptions.value);
  });

  return {
    searchGroups,
    fetchSearchGroups,
    groupOptions,
    populationOptions,
  };
});
